import generateRoutes, { routesEntries } from './ui/routes'

export const proximityRoutes = generateRoutes(routesEntries)
